import PropTypes from "prop-types";

export default PropTypes.shape({
  RuleID: PropTypes.string,
  Question: PropTypes.string,
  AnsLabel: PropTypes.string,
});
